import { Navigate, Route, Routes } from "react-router-dom";
import SalesInventoryIndexPage from "./SalesInventoryIndexPage";
import WarehouseComparePage from "./warehouses/WarehouseComparePage";
import WarehousePage from "./warehouses/WarehousePage";
import StockShipmentRoutes from "./warehouses/shipments";

const Inventory = () => {
  return (
    <Routes>
      <Route index element={<SalesInventoryIndexPage />} />
      <Route path=":stockCategoryId" element={<WarehousePage />} />
      <Route path=":stockCategoryId/compare" element={<WarehouseComparePage />} />
      <Route
        path=":stockCategoryId/shipments/*"
        element={<StockShipmentRoutes />}
      />
      <Route path="*" element={<Navigate to="/sales/inventory" replace />} />
    </Routes>
  );
};

export default Inventory;
